var map = {
	"./header_company.png": 7113,
	"./header_contact.png": 4253,
	"./header_news.png": 5808,
	"./header_partner.png": 5921,
	"./header_privacy-policy.png": 5443,
	"./header_recruit.png": 5728,
	"./header_service.png": 4400,
	"./header_site-policy.png": 5040,
	"./header_top.png": 6859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2680;